import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import ThanksCallout from "../../../../src/components/ThanksCallout";
import passkeylinux from "../../../../assets/images/blogs/pp301/passkey.png";
import specificity1 from "../../../../assets/images/blogs/pp301/specificity1.png";
import specificity2 from "../../../../assets/images/blogs/pp301/specificity2.png";
import specificity3 from "../../../../assets/images/blogs/pp301/specificity3.png";
import placeholdifier from "../../../../assets/images/docs/debugtools/placeholdifier.png";
import sourcepanel from "../../../../assets/images/docs/sourcepanel.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  PolypaneIntro,
  ThanksCallout,
  passkeylinux,
  specificity1,
  specificity2,
  specificity3,
  placeholdifier,
  sourcepanel,
  React
};